const SPEC_TOGGLE_SELECTOR = ".ow-spec-toggle";
const SPEC_1_SELECTOR = ".ow-spec-1 .ow-spec-toggle";
const SPEC_2_SELECTOR = ".ow-spec-2 .ow-spec-toggle";

function specPageChange(col, id) {
  const templateElement = document.getElementById(id);
  if (!templateElement) {
    console.warn(`Template with id '${id}' not found`);
    return;
  }

  const $template = jQuery(templateElement.content);
  if (!$template.length) {
    console.warn(`Template content not found for id '${id}'`);
    return;
  }

  const product = $template.find(".ow-spec-product").html();
  const overview = $template.find('[data-id="overview"]').clone().html();
  const body = $template.find('[data-id="body"]').clone().html();
  const neck = $template.find('[data-id="neck"]').clone().html();
  const details = $template.find('[data-id="details"]').clone().html();
  const accessories = $template.find('[data-id="accessories"]').clone().html();
  jQuery(`.ow-spec-${col} .ow-spec-product`).html(product);
  jQuery(`.ow-spec-overview .ow-spec-${col}`).html(overview);
  jQuery(`.ow-spec-body .ow-spec-${col}`).html(body);
  jQuery(`.ow-spec-neck .ow-spec-${col}`).html(neck);
  jQuery(`.ow-spec-details .ow-spec-${col}`).html(details);
  jQuery(`.ow-spec-accessories .ow-spec-${col}`).html(accessories);
  jQuery(".ow-spec-product img").on("load", function () {
    if (window.matchMedia("(max-width: 798px)").matches) {
      jQuery(".ow-spec-product-img").css({
        height: jQuery(".ow-spec-product img").width() * 1.4,
      });
    } else {
      jQuery(".ow-spec-product-img").css({ height: "auto" });
    }
  });
}

function initSpecComparison() {
  const $spec1 = jQuery(SPEC_1_SELECTOR);
  const $spec2 = jQuery(SPEC_2_SELECTOR);

  if (!$spec1.length || !$spec2.length) {
    console.warn("Spec comparison selectors not found");
    return;
  }

  jQuery(SPEC_TOGGLE_SELECTOR).select2();
  $spec1.prop("selectedIndex", 0);
  $spec2.prop("selectedIndex", $spec2.find("option").length > 1 ? 1 : 0);
  specPageChange(1, $spec1.val());
  specPageChange(2, $spec2.val());
  $spec1.on("change", function () {
    specPageChange(1, jQuery(this).val());
  });
  $spec2.on("change", function () {
    specPageChange(2, jQuery(this).val());
  });
  $spec2.trigger("change");

  jQuery(window).on("load", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const model = urlParams.get("model");
    if (
      model &&
      Array.from($spec1[0].options).some((option) => option.value === model)
    ) {
      $spec1.val(model).trigger("change");
    }
  });
}

initSpecComparison();
